{
  "updateGate": {
    "required": {
      "title": "Update required",
      "body": "This version of Tashkeela is no longer supported. Update to the latest version to keep playing."
    },
    "available": {
      "title": "Update available ✨",
      "body": "A new version of Tashkeela is ready. Update now for the latest features and fixes."
    },
    "ota": {
      "title": "Update ready ✨",
      "body": "A fresh update has been downloaded. Reload now to apply it."
    },
    "cta": "Update",
    "opening": "Opening Play…",
    "reloadCta": "Reload",
    "reloading": "Reloading…",
    "later": "Later"
  },
  "common": {
    "appName": "Tashkeela",
    "retry": "Try again",
    "cancel": "Cancel",
    "save": "Save",
    "done": "Done",
    "close": "Close",
    "back": "Back",
    "gotIt": "Got it",
    "howToPlay": "How to play",
    "share": "Share",
    "viaApp": "via Tashkeela",
    "confirm": "Confirm",
    "delete": "Delete",
    "loading": "Loading…",
    "seeAll": "See all",
    "today": "Today",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow",
    "live": "LIVE",
    "upcoming": "Upcoming",
    "finished": "Full time",
    "ft": "FT",
    "postponed": "Postponed",
    "pts": "pts",
    "min": "min",
    "errorTitle": "Something went wrong",
    "errorBody": "We couldn't load this right now. Check your connection and try again.",
    "emptyTitle": "Nothing here yet",
    "offlineNote": "You appear to be offline.",
    "notConfiguredTitle": "Backend not connected",
    "notConfiguredBody": "Add your Supabase URL and anon key to .env, then restart the app. See README → Setup.",
    "signInRequiredTitle": "Sign in to continue",
    "signInRequiredBody": "Create a free account to build your squad and join leagues.",
    "comingSoon": "Coming soon"
  },
  "tabs": {
    "matches": "Matches",
    "club": "Club HQ",
    "fantasy": "Fantasy",
    "games": "Games",
    "leaderboard": "Ranking",
    "predictions": "Predictions",
    "leagues": "Leagues",
    "search": "Search",
    "profile": "Profile"
  },
  "games": {
    "title": "Games",
    "bracketPredictorTitle": "World Cup Predictor",
    "bracketPredictorBody": "Predict the groups and the whole knockout bracket, and climb the leaderboard.",
    "leaderboardsTitle": "Leaderboards",
    "leaderboardsBody": "See who's on top across predictions and fantasy.",
    "accaTitle": "Acca of the Day",
    "accaBody": "Build a daily parlay from the day's matches. Every leg must hit for the jackpot.",
    "scorePredictTitle": "Score Predictor",
    "scorePredictBody": "Predict the exact scoreline of upcoming matches - nail it for max points.",
    "sportsTitle": "Esports & Sports",
    "sportsBody": "Live tennis, CS:GO, darts, hockey & basketball",
    "totrTitle": "Team of the Round",
    "totrBody": "The best XI of the latest round, by points.",
    "survivorTitle": "Survivor",
    "survivorBody": "Back one nation to win each matchday. Lose once and you're out, and never reuse a nation.",
    "challengesTitle": "Daily Challenges",
    "challengesBody": "Quick match questions every round. Answer before kickoff for bonus points.",
    "qualificationTitle": "Who qualifies?",
    "qualificationBody": "Pick who tops each group, earn coins for every winner you call.",
    "goldenBootTitle": "Golden Boot",
    "goldenBootBody": "Pick the tournament's top scorer and watch the race.",
    "friendLeaguesTitle": "Friend Leagues",
    "friendLeaguesBody": "Make a private league or a 1v1 and battle friends across every game.",
    "bracketLiveTitle": "Live Bracket",
    "bracketLiveBody": "Watch the knockout bracket fill in live and track your prediction.",
    "prizeDrawTitle": "Prize Draw",
    "prizeDrawBody": "Spend the coins you earn on tickets - win the weekly jackpot.",
    "coinsBoardTitle": "Coins Leaderboard",
    "coinsBoardBody": "See the season's richest players and where you rank.",
    "emptyTitle": "More games coming soon",
    "emptyBody": "New games and challenges land here.",
    "albumTitle": "Sticker Album",
    "albumBody": "Collect every World Cup star. Open a free pack daily and fill your album.",
    "wcHeroKicker": "Flagship contest",
    "wcHeroTitle": "Predict the World Cup 🏆",
    "wcHeroSubtitle": "Call every group and the whole knockout bracket, then pick your champion.",
    "wcHeroPrize": "Top 10 win Volt Coins, 500 for 1st place",
    "wcHeroCta": "Play now"
  },
  "wc": {
    "out": "Out",
    "knockedOut": "Knocked out",
    "fantasyEliminatedWarning": "{{count}} of your players are from knocked-out nations and will score 0. Consider transferring them out.",
    "hideEliminated": "Hide out"
  },
  "album": {
    "title": "Sticker Album",
    "intro": "Collect a sticker for every player from the 32 knockout nations. Open a free pack each day, or spend coins for more.",
    "starsTitle": "Tournament Stars",
    "openDaily": "Open daily pack",
    "openDailyFree": "Free today",
    "openDailyDone": "Come back tomorrow",
    "openCoins": "Open pack",
    "opening": "Opening…",
    "packCost": "{{coins}} coins",
    "progressOverall": "{{owned}}/{{total}}",
    "collected": "collected",
    "completePercent": "{{percent}}% complete",
    "signIn": "Sign in to start your collection.",
    "newSticker": "New!",
    "duplicate": "Duplicate",
    "dupeCount": "×{{count}}",
    "revealTitle": "Your stickers",
    "revealNew": "{{count}} new",
    "revealNone": "All duplicates this time - the count goes up!",
    "tapToClose": "Tap to continue",
    "missing": "Not collected yet",
    "teamProgress": "{{owned}}/{{total}}",
    "emptyTitle": "No stickers yet",
    "emptyBody": "The album fills once the World Cup squads are synced.",
    "completeTitle": "Album complete!",
    "completeBody": "You've collected every World Cup sticker. Legendary."
  },
  "challengeFriend": {
    "title": "Challenge a friend",
    "tag": "1v1",
    "subtitle": "Create a 1v1 duel and share the link.",
    "duelName": "{{name}}'s duel",
    "duelFallback": "My 1v1 duel"
  },
  "widgets": {
    "title": "Widgets",
    "intro": "Live glassy widgets for your home screen. Preview them here, then add from your launcher.",
    "free": "Free",
    "matchName": "Match",
    "matchDesc": "Live score, last scorer, next fixtures and group standings.",
    "fantasyName": "Fantasy",
    "fantasyDesc": "Your gameweek points, rank, captain and top performers.",
    "spinName": "Spin Boost",
    "spinDesc": "Your daily Spin Boost status and countdown.",
    "previewAndroidOnly": "Live widget previews appear on Android.",
    "homeTitle": "Add to your home screen",
    "homeStep1": "Press and hold an empty spot on your home screen.",
    "homeStep2": "Tap Widgets, then find Tashkeela.",
    "homeStep3": "Drag the Match widget where you want it.",
    "lockTitle": "Add to your lock screen",
    "lockStep1": "Open your phone's Lock screen settings, then Widgets.",
    "lockStep2": "Add the Tashkeela widget.",
    "lockNote": "Lock screen widgets need Android 16 / One UI 8 or newer. On older phones you still get live scores in your notifications."
  },
  "widgetStyles": {
    "title": "Widget style",
    "subtitle": "Pick the look for your home screen widget. It updates instantly.",
    "gradientName": "Gradient",
    "gradientDesc": "Glassy indigo gradient with a cyan edge. The classic look.",
    "darkName": "Dark",
    "darkDesc": "Solid premium dark card. Clean and high-contrast.",
    "glassName": "Glass",
    "glassDesc": "See-through frosted glass, your wallpaper shows behind it.",
    "minimalName": "Minimal",
    "minimalDesc": "Lighter slate plate with calm, restrained accents.",
    "accentTitle": "Accent color",
    "accentSubtitle": "Recolors the edge, live pill and highlights.",
    "accent_cyan": "Cyan",
    "accent_violet": "Violet",
    "accent_emerald": "Emerald",
    "accent_amber": "Amber",
    "accent_rose": "Rose",
    "layoutTitle": "Layout",
    "layoutSubtitle": "Lead with one match, or a list of upcoming fixtures.",
    "layoutAuto": "Match card",
    "layoutUpcoming": "Upcoming fixtures",
    "favoriteFirstTitle": "Show my team first",
    "favoriteFirstDesc": "Float a team you follow to the top and highlight it."
  },
  "store": {
    "title": "Coins Store",
    "balance": "coins",
    "balanceLabel": "Your balance",
    "framesSection": "Avatar frames",
    "equip": "Equip",
    "equipped": "Equipped",
    "removed": "Frame removed",
    "bought": "Bought! Equip it from here.",
    "equipDone": "Frame equipped",
    "hint": "Spend your Volt Coins on frames that show around your profile photo.",
    "featured": "Featured",
    "ownedTag": "Owned",
    "earnTitle": "Need more coins?",
    "earnHint": "Watch a short ad or hit your daily missions to top up.",
    "frames": {
      "bronze": "Bronze",
      "silver": "Silver",
      "gold": "Gold",
      "volt": "Volt Glow",
      "gradient": "Aurora",
      "champion": "Champion"
    }
  },
  "qualification": {
    "title": "Qualification",
    "intro": "If every group ended now, here's who reaches the Round of 32.",
    "pts": "{{pts}} pts",
    "status": {
      "qualified": "Through",
      "third_in": "Best 3rd",
      "third_out": "On the edge",
      "out": "Out"
    },
    "emptyTitle": "No standings yet",
    "emptyBody": "The projection appears once the group games begin.",
    "predictIntro": "Tap the team you think tops each group. +12 coins for every group winner you call right.",
    "save": "Save my picks",
    "saved": "Picks saved - good luck!",
    "signIn": "Sign in to save your picks.",
    "progress": "{{picked}} of {{total}} groups picked",
    "scoredLine": "Final: {{pts}} pts",
    "yourWinner": "Your pick",
    "tabThrough": "Going through",
    "tabPredict": "Pick winners",
    "throughIntro": "If every group ended now, these 32 teams reach the Round of 32.",
    "qualifiedTitle": "Qualified",
    "bestThirdTitle": "Best 3rd place",
    "qualified": "Qualified",
    "bestThird": "Best 3rd",
    "groupShort": "Grp {{group}}",
    "rankShort": "#{{rank}}",
    "throughEmptyTitle": "No one through yet",
    "throughEmptyBody": "The advancing teams appear once the group games begin."
  },
  "scorePredict": {
    "title": "Score Predictor",
    "intro": "Predict the exact final score of upcoming matches. Exact = 5 pts, right result = 2 pts, plus coins.",
    "totalPts": "total points",
    "signIn": "Sign in to save your predictions.",
    "upcoming": "Upcoming",
    "results": "Your results",
    "save": "Save prediction",
    "saved": "Prediction saved - good luck!",
    "locked": "Saved",
    "yourPick": "Your pick: {{score}}",
    "pts": "pts",
    "leaderboard": "Leaderboard",
    "exactsLine": "{{exacts}} exact",
    "noFixturesTitle": "No matches to predict",
    "noFixturesBody": "Check back when the next fixtures are scheduled.",
    "doubleCta": "Double it - watch a short ad",
    "doubled": "Doubled!",
    "doubledToast": "Doubled! +{{coins}} coins"
  },
  "shareCard": {
    "shareImage": "Share as image",
    "exactHit": "Exact score!",
    "points": "+{{pts}} pts",
    "yourPick": "Your pick",
    "shareLineExact": "Nailed the exact score!",
    "shareLinePoints": "Scored +{{pts}} pts",
    "shareLineYourPick": "My pick: {{score}}"
  },
  "brag": {
    "action": "Brag",
    "kicker": "MY SEASON",
    "subtitle": "Tashkeela predictions",
    "aPlayer": "A Tashkeela player",
    "rankLabel": "GLOBAL RANK",
    "points": "Points",
    "correct": "Correct",
    "streak": "Streak",
    "cta": "Get Tashkeela",
    "shareLineRank": "I'm #{{rank}} on Tashkeela with {{points}} points 🎯",
    "shareLineStreak": "I'm #{{rank}} on Tashkeela · {{streak}}-day streak 🔥"
  },
  "bracketShare": {
    "action": "Share my bracket",
    "kicker": "MY WORLD CUP",
    "championLabel": "MY CHAMPION",
    "noChampion": "No champion yet",
    "points": "Points",
    "rank": "Rank",
    "cta": "Get Tashkeela",
    "shareLineRank": "My World Cup champion is {{champion}}, #{{rank}} on Tashkeela 🏆",
    "shareLineChampion": "I'm backing {{champion}} to win the World Cup on Tashkeela 🏆"
  },
  "winCelebration": {
    "title": "Nailed it!",
    "matchLine": "{{home}} {{score}} {{away}}",
    "wonPoints": "You called it right and banked {{points}} points",
    "wonCoins": "You called it right and won {{coins}} coins",
    "wonPlain": "Your prediction landed",
    "share": "Share",
    "done": "Done",
    "shareLinePoints": "Called {{match}} right on Tashkeela for {{points}} points 🎯",
    "shareLineCoins": "Called {{match}} right on Tashkeela for {{coins}} coins 🪙",
    "shareLinePlain": "Called it right on Tashkeela 🎯"
  },
  "livePredict": {
    "title": "Who scores next?",
    "subtitle": "Call the next goal, live",
    "vs": "or",
    "community": "{{count}} playing",
    "beFirst": "Be the first to call it",
    "yourPickIn": "Your pick is in - good luck!",
    "signIn": "Sign in to play live predictions.",
    "locked": "Pick locked in!"
  },
  "predictWin": {
    "title": "🎯 Predict & Win Coins",
    "subtitle": "Stake coins on the result",
    "forFunTag": "coins, just for fun",
    "draw": "Draw",
    "stakeLabel": "Your stake",
    "balance": "{{coins}} coins",
    "potentialPayout": "Potential payout",
    "placePick": "Place pick",
    "placing": "Placing…",
    "placed": "Pick placed - good luck!",
    "choosePrompt": "Pick an outcome first.",
    "signIn": "Sign in to play.",
    "yourPick": "Your pick: {{side}}",
    "stakedToWin": "Staked {{stake}} · to win {{toWin}}",
    "statusPending": "Waiting for the result…",
    "statusWon": "Won +{{payout}} coins",
    "statusLost": "Didn't land this time.",
    "statusVoid": "Refunded - stake returned."
  },
  "predictWeekly": {
    "title": "Weekly Challenges",
    "subtitle": "Predict & Win · {{done}}/{{total}} done this week",
    "earned": "+{{coins}}",
    "progressRow": "{{done}}/{{target}}",
    "doneRow": "Done · +{{coins}} coins",
    "goals": {
      "place_5": {
        "title": "Place {{target}} predictions"
      },
      "correct_3": {
        "title": "Get {{target}} correct results"
      },
      "underdog_1": {
        "title": "Win an underdog (3×+)"
      }
    },
    "board": {
      "title": "Coins Leaderboard",
      "intro": "Ranked by total coins this season.",
      "you": "You",
      "yourRank": "You're #{{rank}} this season",
      "emptyTitle": "No coins on the board yet",
      "emptyBody": "Play any game to earn coins and climb the ranks."
    }
  },
  "matchReminder": {
    "cta": "Remind me",
    "on": "Reminder on",
    "set": "Reminder set for 10 min before kickoff",
    "removed": "Reminder removed",
    "failed": "Couldn't set a reminder",
    "notifTitle": "⏰ {{home}} vs {{away}}",
    "notifBody": "Kicks off in 10 minutes"
  },
  "today": {
    "firstPredict": {
      "title": "Make your first prediction 🎯",
      "body": "You're all set up. Call the score on a match today to start earning coins and climbing the table.",
      "cta": "Predict a match",
      "later": "Maybe later"
    },
    "title": "Today",
    "coins": "coins",
    "streak": "day streak",
    "matches": "Today's matches",
    "liveCount": "{{count}} live",
    "noMatchesTitle": "No matches today",
    "noMatchesBody": "Check back tomorrow for the next round.",
    "forYou": "For you",
    "picksTitle": "Match predictions",
    "signInPicks": "Sign in to predict today's matches.",
    "picksNone": "Predict today's matches to earn coins.",
    "picksNoMatches": "No matches to predict right now.",
    "picksSummary": "{{made}} picked - {{pending}} still to settle",
    "missionsTitle": "Daily missions",
    "signInMissions": "Sign in to start your daily missions.",
    "missionsSummary": "{{done}}/{{total}} done - {{coins}} coins to grab",
    "missionsAllDone": "All {{total}} missions done. Nice!",
    "sportsTitle": "Esports & Sports",
    "sportsBody": "Live tennis, CS:GO, darts, hockey & basketball.",
    "newsTitle": "World Cup News",
    "newsBody": "Latest tournament news, recaps & headlines.",
    "wcGroupsTitle": "Groups & Bracket",
    "wcGroupsBody": "Full group tables, FIFA ranks & the knockout bracket.",
    "checklist": "Today's checklist",
    "progressDone": "{{done}}/{{total}} done today",
    "allDoneTitle": "All done for today!",
    "allDoneBody": "You've cleared every daily task. Come back tomorrow to keep your streak alive.",
    "streakFlame": "{{count}}-day streak",
    "streakNone": "Start your streak today",
    "go": "Go",
    "claim": "Claim",
    "open": "Open",
    "done": "Done",
    "checkinTitle": "Daily check-in",
    "checkinClaim": "Claim today's reward & grow your streak.",
    "checkinDone": "Checked in - {{count}}-day streak",
    "predictTitle": "Predict today's matches",
    "predictProgress": "{{made}}/{{total}} predicted",
    "predictAllDone": "All {{total}} matches predicted",
    "predictNoneToday": "No matches to predict today.",
    "packTitle": "Open your free daily pack",
    "packAvailable": "A free sticker pack is waiting for you.",
    "packDone": "Daily pack opened - back tomorrow",
    "accaTitle": "Pick'em card of the day",
    "accaProgress": "{{picked}}/{{total}} legs picked",
    "accaAllDone": "All {{total}} legs locked in",
    "accaNoneToday": "No card available today.",
    "potmTitle": "Vote Player of the Match",
    "potmBody": "Have your say on today's standout performer.",
    "potmNone": "No live or finished match to vote on yet.",
    "hubCardTitle": "Today",
    "hubCardBody": "Your daily checklist, streak & matches in one place."
  },
  "discover": {
    "title": "Discover",
    "newsSub": "News, recaps & headlines",
    "groupsSub": "Group tables & bracket",
    "sportsSub": "Live tennis, CS:GO & more",
    "historySub": "Past finals & champions"
  },
  "wcGroups": {
    "title": "World Cup Groups",
    "tabGroups": "Groups",
    "tabBracket": "Bracket",
    "groupsSubtitle": "Live group tables with FIFA ranking, recent form and qualification.",
    "bracketSubtitle": "The road to the final, round by round.",
    "groupNum": "Group {{num}}",
    "played": "P",
    "won": "W",
    "drawn": "D",
    "lost": "L",
    "gf": "GF",
    "ga": "GA"
  },
  "history": {
    "title": "World Cup History",
    "subtitle": "Every final and its champion.",
    "versus": "vs",
    "final": "Final",
    "finalists": "Finalists",
    "showAll": "Show all {{count}}",
    "showLess": "Show less",
    "emptyTitle": "History not available yet",
    "emptyBody": "Past World Cup finals will appear here once the data sync runs."
  },
  "sports": {
    "title": "Esports & Sports",
    "tennis": "Tennis",
    "csgo": "CS:GO",
    "darts": "Darts",
    "hockey": "Hockey",
    "basketball": "Basketball",
    "americanFootball": "Am. Football",
    "baseball": "Baseball",
    "volleyball": "Volleyball",
    "handball": "Handball",
    "rugby": "Rugby",
    "vs": "vs",
    "mode": {
      "live": "Live",
      "upcoming": "Upcoming",
      "finished": "Finished"
    },
    "empty": {
      "live": "No live {{sport}} right now",
      "upcoming": "No upcoming {{sport}}",
      "finished": "No recent {{sport}} results"
    },
    "emptyBody": "Some sports go quiet between seasons. Try another sport or check back soon.",
    "seeUpcoming": "See what's upcoming",
    "footnote": "Powered by the Bzzoiro Sports Addon",
    "footnote365": "Powered by 365Scores"
  },
  "referral": {
    "title": "Invite friends",
    "intro": "Share your code. When a friend joins with it, you BOTH get 100 coins.",
    "yourCode": "Your invite code",
    "invitedCount": "{{n}} friends invited",
    "share": "Share invite link",
    "enterCode": "Got a friend's code?",
    "codePlaceholder": "ENTER CODE",
    "redeem": "Redeem code",
    "redeemed": "Done! +{{coins}} coins for you both",
    "alreadyRedeemed": "You've already redeemed a code.",
    "shareMessage": "Join me on Tashkeela! Tap my invite link and we both get 100 coins: {{link}}\n\nNo link? Enter code {{code}} in the app.",
    "signInHint": "Sign in to get your invite code."
  },
  "howto": {
    "acca": {
      "title": "Acca of the Day",
      "steps": [
        "Pick the result of each of today's matches.",
        "Get them all right to land the accumulator.",
        "Longer winning streaks earn more points and coins."
      ]
    },
    "scorePredict": {
      "title": "Score Predictor",
      "steps": [
        "Predict the exact final score of each upcoming match.",
        "Exact scoreline = 5 points, right result (W/D/L) = 2 points.",
        "Pick up coins for every correct call - spend them across the app."
      ]
    },
    "survivor": {
      "title": "Survivor",
      "steps": [
        "Each round, pick one team you think will win.",
        "Survive if it wins - you're knocked out if it loses.",
        "You can't reuse a team. Last one standing wins."
      ]
    },
    "challenges": {
      "title": "Daily Challenges",
      "steps": [
        "Answer today's quick football questions.",
        "Earn points and coins for every correct answer.",
        "Fresh challenges drop every day - keep your streak alive."
      ]
    },
    "totr": {
      "title": "Team of the Round",
      "steps": [
        "Pick the players you think will shine this round.",
        "Earn +2 points for each pick that makes the official XI, +5 if your captain tops the round.",
        "Compare your team with everyone on the leaderboard."
      ]
    },
    "predictor": {
      "title": "Bracket Predictor",
      "steps": [
        "Predict the group standings and the knockout bracket.",
        "Earn points for every correct call.",
        "Climb the global bracket leaderboard."
      ]
    },
    "qualification": {
      "title": "Group Winners",
      "steps": [
        "Tap the team you think wins each group.",
        "Save your picks before the groups end.",
        "+12 coins for every group winner you nail."
      ]
    },
    "goldenBoot": {
      "title": "Golden Boot",
      "steps": [
        "Pick who you think wins the Golden Boot.",
        "Follow the live top-scorer race.",
        "Call it right to earn big rewards."
      ]
    },
    "friendLeagues": {
      "title": "Friend Leagues",
      "steps": [
        "Create a private league or join with a code.",
        "Compete with friends across all the games.",
        "Top the table on your combined points."
      ]
    },
    "bracketLive": {
      "title": "Live Bracket",
      "steps": [
        "Watch the knockout bracket fill in live.",
        "Track how your prediction is holding up.",
        "Points lock in as each tie is decided."
      ]
    },
    "prizeDraw": {
      "title": "Prize Draw",
      "steps": [
        "Spend the coins you earn to buy tickets.",
        "Each ticket grows the pot and your odds.",
        "A weekly draw - one winner takes the whole pot."
      ]
    },
    "store": {
      "title": "Coins Store",
      "steps": [
        "Spend the coins you earn across the games.",
        "Unlock avatar frames and boosts.",
        "Equip what you buy right from here."
      ]
    }
  },
  "prizeDraw": {
    "title": "Prize Draw",
    "intro": "Spend the coins you earn across every game on tickets. Each ticket grows the pot - one lucky winner takes it all each week.",
    "none": "No draw open right now - check back soon.",
    "pot": "Jackpot",
    "drawsIn": "Draws in {{time}}",
    "myTickets": "My tickets",
    "entrants": "Players",
    "totalTickets": "Total tickets",
    "balance": "Your coins",
    "buy": "Buy a ticket · {{cost}} coins",
    "needCoins": "Earn more coins in the games to enter.",
    "oddsNote": "More tickets = better odds. Winner takes the whole pot.",
    "signIn": "Sign in to enter the draw.",
    "bought": "Ticket bought - good luck!",
    "youWonTitle": "🎉 You won the draw!",
    "youWonBody": "{{pot}} coins have been added to your balance.",
    "lastWinner": "Last winner",
    "wonPot": "{{name}} won {{pot}} coins"
  },
  "bracketLive": {
    "title": "Live Bracket",
    "r32": "Round of 32",
    "r16": "Round of 16",
    "qf": "Quarter-finals",
    "sf": "Semi-finals",
    "final": "Final",
    "yourChampion": "Your champion",
    "noChampion": "No champion picked",
    "tally": "{{correct}}/{{decided}} knockout calls right so far",
    "preKnockout": "The knockout bracket lights up here once the group stage ends.",
    "noBracketTitle": "No bracket yet",
    "noBracketBody": "Predict the World Cup bracket first, then follow it live here.",
    "makeBracket": "Make my bracket"
  },
  "friendLeagues": {
    "title": "Friend Leagues",
    "intro": "A private group ranked by ONE score that adds up your points across every game. Invite friends with a code, or start a 1v1 duel.",
    "createTitle": "Create a league",
    "namePlaceholder": "League name",
    "createLeague": "Create league",
    "createDuel": "1v1 duel",
    "joinTitle": "Join with a code",
    "codePlaceholder": "Invite code",
    "join": "Join",
    "mine": "My leagues",
    "emptyTitle": "No leagues yet",
    "emptyBody": "Create one and share the code, or join a friend's with their code.",
    "memberCount": "{{n}} members",
    "pts": "pts",
    "duelTag": "1v1 duel",
    "signInHint": "Sign in to create and join friend leagues.",
    "nameRequired": "Enter a league name first.",
    "codeRequired": "Enter an invite code.",
    "created": "League created!",
    "joined": "Joined {{name}}!",
    "inviteCode": "Invite code",
    "vs": "VS",
    "standings": "Standings",
    "scoreNote": "Score = your combined points across fantasy, predictions, acca, survivor, Team of the Round, bracket & challenges.",
    "emptyBoard": "No members yet",
    "leave": "Leave league",
    "confirmLeave": "Tap again to leave",
    "shareInvite": "Join my league \"{{name}}\" on Tashkeela! Code: {{code}}",
    "invitePrefilled": "Invite code added - tap Join to enter."
  },
  "goldenBoot": {
    "title": "Golden Boot",
    "intro": "Pick who you think will be the tournament's top scorer.",
    "yourPick": "Your pick",
    "noPick": "No pick yet",
    "pickCta": "Pick",
    "change": "Change",
    "pickRank": "{{goals}} goals · #{{rank}} in the race",
    "noGoalsYet": "No goals yet",
    "race": "Live top scorers",
    "saved": "Pick saved!",
    "share": "Predict the Golden Boot on Tashkeela ⚽",
    "shareMine": "My Golden Boot pick is {{player}} ⚽ Tashkeela"
  },
  "leaderboardsHub": {
    "title": "Leaderboards",
    "acca": "Acca",
    "survivor": "Survivor",
    "bracket": "Predictor",
    "predictions": "Predictions",
    "score": "Scores",
    "fantasy": "Fantasy",
    "round": "This round",
    "totr": "Predicted XI",
    "noDataTitle": "No one's on the board yet",
    "noDataBody": "Be the first to play and you'll show up here."
  },
  "acca": {
    "title": "Acca of the Day",
    "subtitle": "Today's all-or-nothing card",
    "howItWorks": "Pick the result for 3 to 6 of today's matches. Every leg must hit to win the jackpot.",
    "vs": "v",
    "jackpot": "jackpot",
    "started": "Match started, locked",
    "legsPicked": "Legs: {{count}}/6",
    "needThree": "Pick at least 3 to play",
    "allMustHit": "All legs must hit",
    "won": "All correct! +{{points}} pts",
    "lost": "{{hits}}/{{legs}} correct, no jackpot today",
    "daysWon": "{{won}} won / {{played}} days",
    "emptyTitle": "No matches to pick",
    "emptyBody": "Come back when the next matchday is scheduled."
  },
  "totr": {
    "title": "Team of the Round",
    "subtitle": "The best XI of the round",
    "captainLine": "Top scorer: {{name}}",
    "emptyTitle": "No round scored yet",
    "emptyBody": "The dream team appears after the first round is played."
  },
  "totrPredict": {
    "title": "Predict the XI",
    "howto": "Pick the 11 players you think will make the Team of the Round, then name your captain.",
    "locked": "Round locked",
    "lockedShort": "Locked, results soon",
    "liveNow": "Live now, scores update in real time",
    "predictHeader": "Predict {{round}}",
    "closesAt": "Predictions close {{when}}",
    "save": "Save prediction",
    "saved": "Prediction saved! Good luck.",
    "progress": "{{filled}}/11 picked",
    "captainHint": "Tap a player's badge to make them captain (+5 if they top the round).",
    "cta": "Predict this round's XI",
    "edit": "Edit your prediction",
    "yourPrediction": "Your prediction",
    "actualXi": "Actual Team of the Round",
    "noneTitle": "No prediction yet",
    "noneBody": "Predict the XI before the deadline to score points.",
    "hitsOf": "{{hits}}/11",
    "inXi": "In the XI",
    "captain": "Captain",
    "scoringTitle": "How scoring works",
    "scoringRule": "You earn +2 points for every pick that makes the real XI, plus +5 if your captain is the round's top scorer.",
    "yourResult": "Your result",
    "yourPoints": "Your points",
    "leaderboard": "View leaderboard",
    "boardLine": "{{rounds}} rounds · best {{best}}",
    "share": "I'm predicting the Team of the Round on Tashkeela ⚽"
  },
  "rewards": {
    "title": "Rewards",
    "streak": "Day streak",
    "coins": "coins",
    "badges": "Badges",
    "claimDaily": "Claim daily reward",
    "checkinHint": "Open the app every day to grow your streak and earn more coins.",
    "comeBackTomorrow": "Claimed today. Come back tomorrow!",
    "alreadyToday": "Already claimed today.",
    "claimed": "+{{coins}} coins! {{streak}}-day streak",
    "storeTitle": "Coins Store",
    "storeHint": "Spend your coins on profile frames",
    "watchAdTitle": "Watch & earn coins",
    "watchAdHint": "Watch a short ad for {{coins}} coins",
    "adReward": "Nice! +{{coins}} coins",
    "adCapReached": "Daily ad limit reached - back tomorrow!",
    "adLeft": "{{n}} left today",
    "adRewardsLeft": "{{n}} ad rewards left today",
    "adBackTomorrow": "Back tomorrow for more",
    "level": {
      "chip": "Lv {{level}}",
      "xp": "{{into}}/{{total}} XP"
    },
    "prizeWon": "You finished #{{rank}} and won {{coins}} coins in {{round}}!",
    "streakCalendar": "Your streak",
    "freezesLabel": "{{n}} freezes",
    "buyFreeze": "Buy freeze · {{coins}}",
    "freezeBought": "Streak freeze added. One missed day is on us.",
    "streakModal": {
      "title": "Daily streak",
      "dayN": "Day {{day}}",
      "subtitle": "Open the app every day to keep your streak alive.",
      "claim": "Claim today",
      "later": "Maybe later"
    },
    "missions": "Daily missions",
    "mission": {
      "open_app": "Check in today",
      "make_prediction": "Predict the Team of the Round",
      "play_challenge": "Answer 3 match challenges",
      "submit_acca": "Build an Acca of the Day",
      "survivor_pick": "Make your Survivor pick",
      "spin_today": "Use your daily Spin",
      "follow_player": "Follow a player or team"
    },
    "achievements": "Achievements",
    "signInTitle": "Sign in for rewards",
    "ach": {
      "first_squad": { "title": "Squad Builder", "desc": "Create your World Cup fantasy team." },
      "first_captain": { "title": "Armband On", "desc": "Pick a captain for your squad." },
      "first_challenge": { "title": "Challenger", "desc": "Answer a daily match challenge." },
      "first_prediction": { "title": "Forecaster", "desc": "Make a match prediction." },
      "predict_correct": { "title": "Called It", "desc": "Get a match prediction right." },
      "first_acca": { "title": "Acca Builder", "desc": "Build your first Acca of the Day." },
      "acca_jackpot": { "title": "Jackpot!", "desc": "Win an Acca with every leg correct." },
      "survivor_join": { "title": "Survivor", "desc": "Enter the Last-Man-Standing pool." },
      "survivor_run": { "title": "Last One Standing", "desc": "Survive three Survivor rounds." },
      "spin_master": { "title": "Spin Master", "desc": "Use the Spin Boost." },
      "follow_five": { "title": "Superfan", "desc": "Follow five teams or players." },
      "streak_seven": { "title": "On Fire", "desc": "Reach a seven-day streak." },
      "score_first": { "title": "Score Caller", "desc": "Predict an exact scoreline." },
      "score_exact": { "title": "Bang On", "desc": "Nail an exact final score." },
      "prize_ticket": { "title": "In the Draw", "desc": "Buy a prize draw ticket." },
      "prize_winner": { "title": "Jackpot Winner", "desc": "Win the weekly prize draw." },
      "coin_collector": { "title": "Coin Collector", "desc": "Hold 1,000 coins at once." },
      "friend_league": { "title": "Squad Up", "desc": "Join or create a friend league." }
    }
  },
  "survivor": {
    "title": "Survivor",
    "subtitle": "Last one standing wins",
    "howItWorks": "Each matchday, back one nation to WIN. A draw or loss knocks you out, and you can never pick the same nation twice.",
    "versus": "v {{opponent}} · {{time}}",
    "eliminated": "Knocked out in {{round}}",
    "stillAlive": "Still alive",
    "notJoined": "Pick a nation to enter",
    "roundsSurvived": "{{count}} rounds survived",
    "thisRound": "This round",
    "locked": "Locked in",
    "yourPick": "Your pick, tap another to change",
    "noOptionsTitle": "No open match to pick",
    "noOptionsBody": "Come back before the next matchday kicks off.",
    "history": "Your run",
    "stillIn": "Still in",
    "knockedOut": "Knocked out"
  },
  "club": {
    "title": "CLUB HQ",
    "season": "Season {{number}}",
    "managerRank": "MANAGER RANK",
    "squadOvr": "SQUAD OVR",
    "chemistry": "CHEMISTRY",
    "budget": "BUDGET",
    "trainingCenter": "TRAINING CENTER",
    "trainingReady": "Squad training session",
    "trainingHint": "Boosts chemistry before the next gameweek.",
    "nextMatch": "NEXT MATCH",
    "transferTarget": "AI TRANSFER TARGET",
    "tactics": "TACTICS",
    "highLine": "Attacking shape",
    "noClubTitle": "Your club starts with a squad",
    "noClubBody": "Build your fantasy squad first; Club HQ runs on the same players.",
    "noClubCta": "Build my squad"
  },
  "predictions": {
    "title": "Predictions",
    "subtitle": "Pick results, earn points, climb the board",
    "pick": "TIP: {{name}}",
    "draw": "DRAW",
    "keyFactorBoth": "Key factor: {{home}} form {{homeForm}} vs {{away}} {{awayForm}}.",
    "keyFactorHome": "Key factor: {{home}} recent form {{homeForm}} at home.",
    "keyFactorNone": "Key factor: early stage, the form guide leans on home advantage.",
    "noFixturesTitle": "No upcoming matches to predict",
    "noFixturesBody": "Predictions appear for matches in the next 7 days.",
    "myPoints": "My points",
    "yourPick": "Your pick",
    "locked": "Locked",
    "correct": "Correct · +{{points}}",
    "missed": "Missed this one",
    "pointsPerCorrect": "Correct result = +{{points}} points",
    "leaderboard": "Leaderboard",
    "overall": "Overall",
    "groups": "Friends",
    "createGroup": "Create a group",
    "joinGroup": "Join with a code",
    "groupName": "Group name",
    "groupNamePlaceholder": "e.g. The Office League",
    "signInToPlay": "Sign in to make picks and earn points",
    "yourPrediction": "Your prediction",
    "tallyCount_one": "{{count}} prediction",
    "tallyCount_other": "{{count}} predictions",
    "predictFromMatches": "Predict any match from its own screen. Open a match and pick the result to earn points.",
    "topPredictors": "Top predictors",
    "record": "{{correct}} correct of {{played}}",
    "emptyBoardTitle": "No points on the board yet",
    "emptyBoardBody": "Picks score after their matches finish. Be the first!",
    "noGroupsTitle": "No groups yet",
    "noGroupsBody": "Create one and invite your friends with the code."
  },
  "howTo": {
    "title": "How to play",
    "fantasyTitle": "Fantasy in 60 seconds",
    "fantasyIntro": "Build a 15-player squad within a {{budget}}M budget: 2 goalkeepers, 5 defenders, 5 midfielders and 3 forwards. Choose your starting XI, a captain who scores ×{{multiplier}}, and a vice-captain who takes over if the captain doesn't play. Lineups lock at every gameweek deadline. Changes after that count from the next gameweek.",
    "pointsTitle": "How players earn points",
    "predictionsTitle": "Predictions game",
    "predictionsBody": "Before kickoff, pick the result: home win, draw or away win. Every correct pick earns +{{points}} points. Climb the overall leaderboard, or create a private group and invite your friends with a code.",
    "rows": {
      "played60": "Playing 60+ minutes",
      "played": "Playing 1-59 minutes",
      "goalGK": "Goal by a goalkeeper or defender",
      "goalMID": "Goal by a midfielder",
      "goalFWD": "Goal by a forward",
      "assist": "Assist",
      "cleanSheetDef": "Clean sheet (GK / DEF)",
      "cleanSheetMid": "Clean sheet (MID)",
      "saves": "Every {{count}} saves (GK)",
      "penSave": "Penalty saved (GK)",
      "penMiss": "Penalty missed",
      "conceded": "Every {{count}} goals conceded (GK / DEF)",
      "yellow": "Yellow card",
      "red": "Red card",
      "ownGoal": "Own goal",
      "bonus": "Match bonus (top 3 performers)"
    }
  },
  "matches": {
    "title": "Matches",
    "noMatchesTitle": "No matches on this day",
    "noMatchesBody": "Pick another date or browse a competition's full schedule.",
    "liveNow": "Live now",
    "kickoff": "Kick-off",
    "round": "Round",
    "matchday": "Matchday {{number}}",
    "group": "Group",
    "hot": "Featured match",
    "featured": "BIG MATCH",
    "featuredMatch": "Featured match",
    "yourTeam": "Your team is playing",
    "vs": "vs",
    "winShort": "WIN",
    "drawShort": "DRAW",
    "homeForm": "HOME FORM",
    "awayForm": "AWAY FORM",
    "modelInsight": "Model insight",
    "insightStrongHome": "{{team}} strong favourites at home · {{pct}}% by the form model.",
    "insightStrongAway": "{{team}} favoured away · {{pct}}% by the form model.",
    "insightTight": "Tight call · the form model splits {{home}} {{homePct}}% vs {{away}} {{awayPct}}%.",
    "filterAll": "All",
    "filterLive": "Live",
    "filterFollowing": "Following",
    "followingEmptyTitle": "No followed matches today",
    "followingEmptyBody": "Follow teams and competitions with the ★ to gather their matches here.",
    "noLiveTitle": "No live matches right now",
    "noLiveBody": "Nothing kicking off at the moment. Check back when games go live.",
    "competitions": "Competitions"
  },
  "favorites": {
    "follow": "Follow",
    "following": "Following"
  },
  "following": {
    "title": "Following",
    "teams": "Teams",
    "competitions": "Competitions",
    "players": "Players",
    "yourTeams": "Your teams",
    "yourCompetitions": "Your competitions",
    "yourPlayers": "Your players",
    "suggested": "Suggested",
    "allCompetitions": "All competitions",
    "noPlayersTitle": "No players followed",
    "noPlayersBody": "Open a player and tap the star to follow them here."
  },
  "notifications": {
    "title": "Notifications",
    "matchAlerts": "Match alerts",
    "fantasy": "Fantasy",
    "fulltimeAlerts": "Full-time results",
    "goalHint": "Get a buzz the moment a goal goes in.",
    "followedOnlyHint": "Only for matches involving a team you follow.",
    "fulltimeHint": "The final score when a followed team's match ends.",
    "ratingAlerts": "Player ratings",
    "ratingHint": "A player you follow gets their post-match rating.",
    "prematchAlerts": "Match reminders",
    "prematchHint": "A heads-up about an hour before a followed team kicks off.",
    "deadlineHint": "A nudge ~24h before a fantasy deadline.",
    "widgets": "Widgets",
    "widgetMatchTitle": "Home-screen widgets",
    "widgetMatchBody": "Live score and scorer, group standings, fixtures, your fantasy points and Spin status, in 3 sizes.",
    "widgetHowTo": "Add them from your home screen: long-press an empty area, tap Widgets, then find Tashkeela (Match, Fantasy, Spin). Live scores also appear on your lock screen during matches.",
    "settingUp": "Push notifications are being set up and will start arriving in an upcoming update. Your choices below are saved.",
    "testTitle": "⏱️ Full time",
    "testBody": "🇲🇦 Morocco 2 - 1 Brazil 🇧🇷",
    "testTitle2": "Send a test notification",
    "testHint": "Check it shows up on your screen",
    "testSent": "Test sent. Check your notifications!"
  },
  "notifSettings": {
    "title": "Notifications",
    "subtitle": "Pick the alerts you want. Changes save instantly.",
    "sectionMatch": "Match alerts",
    "sectionFantasy": "Fantasy",
    "goalLabel": "Goal alerts",
    "goalHint": "Get a buzz the moment a goal goes in.",
    "followedOnlyLabel": "My teams only",
    "followedOnlyHint": "Limit goal and result alerts to teams you follow.",
    "fulltimeLabel": "Full-time results",
    "fulltimeHint": "The final score when a followed team's match ends.",
    "reminderLabel": "Match reminders",
    "reminderHint": "A heads-up about an hour before kickoff.",
    "deadlineLabel": "Deadline reminders",
    "deadlineHint": "A nudge ~24h before a fantasy deadline.",
    "ratingLabel": "Player ratings",
    "ratingHint": "A player you follow gets their post-match rating.",
    "osDisabledTitle": "Notifications are off for Tashkeela",
    "osDisabledBody": "Your choices here are saved, but your phone won't show alerts until you enable notifications in system settings.",
    "osDisabledAction": "Open settings",
    "settingUp": "Push notifications are being set up and will start arriving in an upcoming update. Your choices below are saved.",
    "guestTitle": "Sign in to set up alerts",
    "guestBody": "Your notification choices sync to your account, so sign in to save them."
  },
  "more": {
    "title": "More",
    "predictor": "Predictor",
    "lineupBuilder": "Lineup Builder",
    "transferCenter": "Transfer Center",
    "tvSchedules": "TV schedules",
    "notifications": "Notifications",
    "settings": "Settings",
    "comingSoon": "Soon",
    "profile": "Profile",
    "profileSub": "Sync your settings across devices."
  },
  "predictor": {
    "title": "Bracket Predictor",
    "groupsTitle": "Predict the groups",
    "groupsHint": "Tap the teams in your predicted finishing order (1st to 4th) for every group.",
    "thirdsTitle": "Best third-placed teams",
    "thirdsHint": "Pick the 8 third-placed teams you think advance to the Round of 32.",
    "reset": "Reset",
    "nextRound": "Next",
    "save": "Save my bracket",
    "saved": "Your bracket is saved",
    "champion": "Your champion",
    "leaderboard": "Predictor leaderboard",
    "points": "Points",
    "rank": "Rank",
    "emptyBoardTitle": "No predictions yet",
    "emptyBoardBody": "Be the first to predict the bracket. Points are awarded as results come in.",
    "awaiting": "Decided by earlier rounds",
    "emptyTitle": "Groups not drawn yet",
    "emptyBody": "The bracket predictor opens once the World Cup groups are set.",
    "round": {
      "R32": "R32",
      "R16": "R16",
      "QF": "QF",
      "SF": "SF",
      "F": "Final"
    },
    "legendQualify": "Qualify",
    "legendThird": "3rd",
    "legendOut": "Out",
    "knockoutHint": "Pick the winners round by round. They carry into the next round.",
    "random": "🎲 Random",
    "lockTitle": "Lock your prediction?",
    "lockBody": "Once you confirm, you can’t change it. Your bracket is final for the leaderboard, points and prizes.",
    "lockConfirm": "Confirm & lock",
    "championLabel": "Your champion",
    "championCta": "Choose your champion 🏆",
    "rankStat": "You're {{rank}} · {{points}} pts",
    "prizeTitle": "Prizes",
    "prizeBody": "The top 10 predictors win Volt Coins."
  },
  "news": {
    "title": "News",
    "subtitle": "Match recaps, written automatically from the live data.",
    "beat": "{{winner}} beat {{loser}} {{score}}.",
    "drew": "{{home}} and {{away}} drew {{score}}.",
    "ownGoal": "OG",
    "emptyTitle": "No recaps yet",
    "emptyBody": "Match recaps appear here as games finish. Check back soon.",
    "tabHeadlines": "Headlines",
    "tabRecaps": "Match recaps",
    "tabWorldCup": "World Cup",
    "wcTitle": "World Cup News",
    "wcEmptyTitle": "No World Cup news yet",
    "wcEmptyBody": "Tournament news lands here as it breaks. Check back soon.",
    "magazine": "Feature",
    "timeNow": "Just now",
    "time": {
      "minutes": "{{count}}m ago",
      "hours": "{{count}}h ago",
      "days": "{{count}}d ago"
    },
    "headlinesEmptyTitle": "No headlines yet",
    "headlinesEmptyBody": "Fresh football headlines land here through the day."
  },
  "transfers": {
    "title": "Transfer Center",
    "subtitle": "Where the tournament's players have moved, straight from the data feed.",
    "free": "Free",
    "loan": "Loan",
    "undisclosed": "Undisclosed",
    "emptyTitle": "No transfers yet",
    "emptyBody": "The mercato board fills as moves land. Check back soon."
  },
  "wcFantasy": {
    "title": "World Cup Fantasy",
    "squad": "Squad",
    "budget": "Budget",
    "randomizer": "Randomizer",
    "randomizerHint": "Spin to draw a nation, then pick a player for an open position. Max 3 per nation, at least one Arab nation.",
    "spin": "Spin a nation",
    "full": "Squad complete",
    "noSlotForNation": "No open slot for this nation. Spin again.",
    "manual": "Or pick manually",
    "yourSquad": "Your squad",
    "viewPhotos": "Show player photos",
    "viewFlags": "Show nation flags",
    "bench": "Bench",
    "teamNamePlaceholder": "Your team name",
    "save": "Save squad",
    "saving": "Saving…",
    "savedToast": "Squad saved ⚽",
    "saveError": "Could not save. Check your squad and try again.",
    "unavailableTitle": "World Cup fantasy isn't live yet",
    "unavailableBody": "The World Cup season hasn't been set up. Check back soon.",
    "issueNeeds": "Need {{count}} more {{position}}",
    "issueBudget": "Over budget by {{amount}}",
    "issueNation": "Too many from {{nation}} (max {{max}})",
    "issueArab": "Add {{count}} more Arab-nation player",
    "issueFormation": "Invalid formation",
    "issueIncomplete": "Squad incomplete"
  },
  "privacy": {
    "title": "Privacy policy",
    "updated": "Last updated 16 June 2026",
    "collectTitle": "What we collect",
    "collectBody": "When you sign in we store your email, display name, and (if you use Google or Facebook) your profile photo. We also keep the teams, competitions and players you follow, your predictions, your fantasy squads, your language preference, and (on mobile, if enabled) a push token for notifications. We do not collect your location or contacts. To keep the app free, we show ads through Google AdMob, which uses your device's advertising ID.",
    "useTitle": "How we use it",
    "useBody": "Only to run the app: your account, personalization, leaderboards, and the notifications you opt into. We never sell your data. Ads are served by Google AdMob, which may use your device's advertising ID to show and measure ads.",
    "providersTitle": "Service providers",
    "providersBody": "We use trusted infrastructure providers for sign-in and database, push notifications, and ads (Google AdMob), plus Google/Facebook only if you sign in with them. Football data comes from a licensed third-party provider; none of your personal data is sent there.",
    "securityTitle": "Security",
    "securityBody": "Data is encrypted in transit (HTTPS), and database access is restricted by row-level security so you can only read and write your own account.",
    "deletionTitle": "Your choices & deletion",
    "deletionBody": "You can delete your account anytime from Profile → Delete account, which permanently removes your data. You can also toggle notifications in Profile, or email us to request deletion.",
    "childrenTitle": "Children",
    "childrenBody": "Tashkeela is not directed to children under 13 and we do not knowingly collect their data.",
    "contactTitle": "Contact",
    "contactBody": "Questions? Email us at"
  },
  "match": {
    "title": "Match",
    "events": "Events",
    "lineups": "Lineups",
    "ratings": "Ratings",
    "stats": "Stats",
    "standings": "Table",
    "news": "Match news",
    "trendsTitle": "Form Trends",
    "trendsTeam": "By team",
    "trendsGeneral": "General",
    "noEventsTitle": "No events yet",
    "noEventsBody": "Key moments will appear here as they happen.",
    "noLineupsTitle": "Lineups not available",
    "noLineupsBody": "Lineups are usually published about an hour before kick-off.",
    "noRatingsTitle": "Ratings not available yet",
    "noRatingsBody": "Player ratings appear once the match is underway.",
    "playerOfTheMatch": "Player of the match",
    "ratingsHint": "Live ratings update as the match plays out.",
    "comparison": "Key players",
    "statGoals": "{{count}} ⚽",
    "statAssists": "{{count}} 🅰",
    "statSaves": "{{count}} 🧤",
    "statMinutes": "{{count}}′",
    "topScorer": "Top scorer",
    "keyPlayer": "Most dangerous",
    "standing": "Group",
    "noStatsTitle": "Stats not available",
    "noStatsBody": "This competition doesn't provide detailed match statistics.",
    "noStandingsTitle": "No table available",
    "noStandingsBody": "Standings are not provided for this stage.",
    "h2h": "Head-to-Head",
    "h2hNoHistory": "First meeting",
    "h2hHistoryEmpty": "These teams have no recorded previous meetings.",
    "h2hWins": "Wins",
    "h2hDraws": "Draws",
    "h2hRecent": "Previous meetings",
    "h2h365Title": "Head to Head",
    "h2h365Recent": "Recent meetings",
    "h2h365Form": "Recent form",
    "formWin": "W",
    "formDraw": "D",
    "formLoss": "L",
    "goal": "Goal",
    "ownGoal": "Own goal",
    "penalty": "Penalty",
    "penaltyMissed": "Penalty missed",
    "yellowCard": "Yellow card",
    "redCard": "Red card",
    "substitution": "Substitution",
    "var": "VAR",
    "assistBy": "Assist: {{name}}",
    "possession": "Possession",
    "xg": "Expected goals",
    "xgShort": "xG",
    "bigChances": "Big chances",
    "shotmap": "Shot map",
    "onTarget": "On target",
    "offTarget": "Off target",
    "blocked": "Blocked",
    "sizeIsXg": "Dot size = xG",
    "shotmapHint": "Each dot is a shot, placed by where it was taken. Bigger dots are better chances. The home team attacks the right goal, the away team the left.",
    "noShots": "No shots recorded",
    "xgValue": "{{value}} xG",
    "noXgTitle": "Advanced stats not available",
    "noXgBody": "xG and the shot map appear once detailed data is synced for this match.",
    "xgPreparing": "Match analytics are being prepared. Check back shortly.",
    "draw": "Draw",
    "momentum": "xG momentum",
    "momentumHint": "Cumulative expected goals · dots are goals",
    "momentumWave": "Momentum",
    "momentumWaveHint": "Attacking pressure over time · above the line is the home team",
    "playerRatings": "Player ratings",
    "starMan": "Star man",
    "tapForMore": "Tap a player for more",
    "phaseAll": "Full match",
    "phaseFirstHalf": "1st half",
    "phaseSecondHalf": "2nd half",
    "groupShots": "Shots",
    "groupAttack": "Attack",
    "groupPasses": "Passing",
    "groupDuels": "Duels",
    "groupDefending": "Defending",
    "groupGoalkeeping": "Goalkeeping",
    "statTotalShots": "Total shots",
    "statShotsInsideBox": "Shots inside box",
    "statShotsOutsideBox": "Shots outside box",
    "statHitWoodwork": "Hit woodwork",
    "statBlockedShots": "Blocked shots",
    "statTouchesInBox": "Touches in box",
    "statFinalThirdEntries": "Final third entries",
    "statBigChances": "Big chances",
    "statCrosses": "Accurate crosses",
    "statLongBalls": "Accurate long balls",
    "statThrowIns": "Throw-ins",
    "statAccuratePasses": "Accurate passes",
    "statDuelsWon": "Duels won",
    "statAerialDuels": "Aerial duels won",
    "statGroundDuels": "Ground duels won",
    "statDribbles": "Dribbles success",
    "statDispossessed": "Dispossessed",
    "statTackles": "Tackles",
    "statTacklesWon": "Tackles won",
    "statClearances": "Clearances",
    "statInterceptions": "Interceptions",
    "statRecoveries": "Ball recoveries",
    "statSaves": "Saves",
    "statGoalsPrevented": "Goals prevented",
    "ratingXa": "xA",
    "ratingShots": "Shots",
    "ratingKeyPasses": "Key passes",
    "ratingTackles": "Tackles",
    "ratingDuelsWon": "Duels won",
    "ratingPassAccuracy": "Pass accuracy",
    "ratingInterceptions": "Interceptions",
    "ratingClearances": "Clearances",
    "ratingRecoveries": "Recoveries",
    "ratingTouches": "Touches",
    "avgPositions": "Average positions",
    "avgPositionsHint": "Where each player spent most of the match on average. The home team attacks right, the away team left. Tap a number for the name.",
    "shots": "Shots",
    "shotsOnTarget": "Shots on target",
    "passes": "Passes",
    "passesAccurate": "Accurate passes",
    "passAccuracy": "Pass accuracy",
    "yellowCards": "Yellow cards",
    "redCards": "Red cards",
    "fouls": "Fouls",
    "corners": "Corners",
    "offsides": "Offsides",
    "saves": "Saves",
    "bench": "Bench",
    "coach": "Coach",
    "absences": "Absences",
    "injured": "Injured",
    "suspended": "Suspended",
    "formation": "Formation",
    "halfTime": "HT",
    "fullTime": "FT",
    "timelineAll": "All",
    "timelineKey": "Highlights",
    "competition": "Competition",
    "venue": "Venue",
    "predictionTitle": "Match prediction",
    "modelInsight": "Model Insight",
    "modelBeta": "Form model · beta",
    "modelBasis": "Based on recent form, points-per-game and goal difference.",
    "insightFavoured": "The model leans towards {{team}}.",
    "insightEven": "Too close to call. A draw is in play.",
    "insightStrong": "Strong lean",
    "insightSlight": "Slight lean",
    "recentForm": "Form",
    "ppgShort": "PPG",
    "kicksOffIn": "Kicks off in",
    "unitDays": "Days",
    "unitHours": "Hrs",
    "unitMins": "Min",
    "unitSecs": "Sec",
    "live": "Live",
    "goalPlacement": "Goal placement",
    "viewPitch": "Pitch",
    "viewGoal": "Goal",
    "noGoalPlacement": "No on-target shots",
    "referee": "Referee",
    "refGames": "Games",
    "refYellowAvg": "Yellows/game",
    "refReds": "Reds",
    "prediction": "Prediction",
    "predictionModel": "Model {{version}}",
    "predictionMostLikely": "Most likely score",
    "predictedLineup": "Predicted lineup",
    "predictedBadge": "Predicted",
    "posGoalkeeper": "Goalkeeper",
    "posDefence": "Defence",
    "posMidfield": "Midfield",
    "posAttack": "Attack",
    "whereToWatch": "Where to watch",
    "playerDetail": {
      "openProfile": "Open {{name}} profile",
      "loading": "Loading profile",
      "noProfile": "Detailed profile not available for this player.",
      "season": "Season",
      "rating": "Rating",
      "appearances": "Apps",
      "minutes": "Minutes",
      "conversion": "Conversion",
      "bigChances": "Big chances",
      "yearsOld": "{{count}} yrs",
      "cm": "cm",
      "preferredFoot": "Foot",
      "marketValue": "Market value",
      "contractUntil": "Contract until",
      "heatmap": "Heatmap",
      "heatmapUnavailable": "Heatmap not available for this match"
    },
    "playerStats": {
      "title": "Match stats",
      "rating": "Rating",
      "starter": "Started",
      "derivedNote": "Rating estimated from this match's stats.",
      "fullProfile": "Full profile",
      "minutes": "Minutes",
      "goals": "Goals",
      "assists": "Assists",
      "shots": "Shots",
      "passes": "Passes",
      "tackles": "Tackles",
      "saves": "Saves",
      "conceded": "Conceded",
      "yellowCards": "Yellow cards",
      "redCards": "Red cards",
      "penaltySaved": "Pens saved",
      "penaltyMissed": "Pens missed",
      "ownGoals": "Own goals",
      "goalsCount": "{{count}} goals",
      "assistsCount": "{{count}} assists",
      "yellowCard": "Yellow card",
      "redCard": "Red card"
    },
    "matchInfo": {
      "venue": "Stadium",
      "capacity": "{{value}} capacity",
      "builtYear": "Built {{value}}",
      "weather": "Weather",
      "degrees": "{{value}}°C",
      "wind": "Wind {{value}} km/h",
      "neutralGround": "Neutral ground",
      "derby": "Derby",
      "weatherDesc": {
        "clear": "Clear",
        "cloudy": "Cloudy",
        "partlyCloudy": "Partly cloudy",
        "overcast": "Overcast",
        "rain": "Rain",
        "snow": "Snow",
        "thunderstorm": "Thunderstorm",
        "fog": "Fog",
        "windy": "Windy"
      }
    }
  },
  "potm": {
    "title": "Player of the Match",
    "subtitle": "Vote for your standout",
    "subtitleFinal": "Who was the best on the pitch?",
    "voted": "Your vote is in",
    "changeHint": "Tap another player to change your vote",
    "votes": "{{count}} votes",
    "votesOne": "1 vote",
    "votesTwo": "{{count}} votes",
    "votesFew": "{{count}} votes",
    "totalVotes": "{{count}} fans voted",
    "leading": "Leading",
    "winner": "Fans' MVP",
    "beFirst": "Be the first to vote",
    "signIn": "Sign in to vote.",
    "showAll": "Show all players",
    "showLess": "Show fewer",
    "home": "Home",
    "away": "Away"
  },
  "compare": {
    "openTitle": "Compare players",
    "openSubtitle": "Put any two players head-to-head",
    "openLabel": "Compare two players head-to-head",
    "title": "Head-to-head",
    "collapse": "Hide",
    "vs": "VS",
    "tapHint": "Tap a player to swap them. The better value in each row is highlighted.",
    "changePlayer": "Change player ({{name}})",
    "pickTitle": "Choose player {{slot}}",
    "winsCount_one": "{{n}} stat",
    "winsCount_other": "{{n}} stats",
    "metricRating": "Rating",
    "metricMinutes": "Minutes",
    "metricGoals": "Goals",
    "metricAssists": "Assists",
    "metricXg": "xG",
    "metricXa": "xA",
    "metricShots": "Shots",
    "metricShotsOnTarget": "On target",
    "metricKeyPasses": "Key passes",
    "metricBigChances": "Big chances",
    "metricPasses": "Passes",
    "metricPassAccuracy": "Pass accuracy"
  },
  "highlights": {
    "title": "Highlights"
  },
  "livePitch": {
    "title": "Live Pitch",
    "connecting": "Connecting to the live feed…",
    "reconnecting": "Reconnecting…",
    "notTracked": "Live tracking is not available for this match",
    "error": "The live feed is unavailable right now",
    "inPossession": "In possession",
    "situations": {
      "regular_play": "Open play",
      "free_kick": "Free kick",
      "corner_kick": "Corner kick",
      "corner": "Corner",
      "goal_kick": "Goal kick",
      "throw_in": "Throw-in",
      "penalty": "Penalty",
      "kick_off": "Kick-off",
      "goal": "Goal!",
      "safe": "Safe",
      "attack": "Attack",
      "dangerous_attack": "Dangerous attack",
      "shotoffwoodwork": "Off the woodwork"
    },
    "actions": {
      "goal": "Goal!",
      "shot": "Shot",
      "yellow": "Yellow card",
      "red": "Red card",
      "save": "Save",
      "corner": "Corner",
      "penalty": "Penalty",
      "woodwork": "Off the woodwork"
    }
  },
  "liveAlerts": {
    "goalTitle": "⚽ GOAL!",
    "redCardTitle": "🟥 Red Card",
    "redCardBody": "{{player}}",
    "flashGoal": "Goal!",
    "flashRedCard": "Red card"
  },
  "leagues": {
    "title": "Leagues",
    "standings": "Standings",
    "topScorers": "Top scorers",
    "topAssists": "Top assists",
    "topAssists": "Top assists",
    "teams": "Teams",
    "fixtures": "Fixtures",
    "pos": "#",
    "team": "Team",
    "played": "P",
    "won": "W",
    "drawn": "D",
    "lost": "L",
    "goalDiff": "GD",
    "points": "Pts",
    "form": "Form",
    "modeShort": "Short",
    "modeFull": "Full",
    "modeForm": "Form",
    "venue_overall": "Overall",
    "venue_home": "Home",
    "venue_away": "Away",
    "group": "Group {{name}}",
    "zoneQualify": "Qualification",
    "zoneRelegation": "Relegation",
    "liveStandings": "Live table",
    "bracket": "Bracket",
    "stageLast64": "Round of 64",
    "stageLast32": "Round of 32",
    "stageLast16": "Round of 16",
    "stageQuarter": "Quarter-finals",
    "stageSemi": "Semi-finals",
    "stageThird": "Third place",
    "stageFinal": "Final",
    "stageRound": "Round",
    "noBracketTitle": "Bracket not available yet",
    "noBracketBody": "The knockout bracket appears once the group stage is complete.",
    "noStandingsTitle": "No standings yet",
    "noStandingsBody": "The table will appear once the data sync runs.",
    "noCompetitionsTitle": "No competitions yet",
    "noCompetitionsBody": "Competitions appear after the first data sync. See README → Setup.",
    "fantasyAvailable": "Fantasy available",
    "goalsShort": "Goals",
    "assistsShort": "Assists",
    "offSeasonTitle": "No matches right now",
    "offSeasonBody": "This league is between seasons. The full table and squads are ready in the other tabs.",
    "offSeasonScorers": "Top scorers will appear once the new season kicks off.",
    "viewStandings": "View the table"
  },
  "team": {
    "squad": "Squad",
    "venue": "Stadium",
    "setFavorite": "Set as my club",
    "unsetFavorite": "Remove my club",
    "favoriteSet": "Saved as your favourite team",
    "noPlayersTitle": "Squad not loaded yet",
    "noPlayersBody": "Player data syncs gradually to respect free API limits. Check back soon."
  },
  "player": {
    "stats": "Season stats",
    "fantasyPrice": "Fantasy price",
    "fantasyPoints": "Fantasy points",
    "recentForm": "Recent form",
    "noStatsTitle": "No stats yet",
    "noStatsBody": "Match-by-match numbers appear once this player features in a synced match.",
    "positions": {
      "GK": "Goalkeeper",
      "DEF": "Defender",
      "MID": "Midfielder",
      "FWD": "Forward"
    },
    "positionsShort": {
      "GK": "GK",
      "DEF": "DEF",
      "MID": "MID",
      "FWD": "FWD"
    },
    "minutes": "Minutes",
    "goals": "Goals",
    "assists": "Assists",
    "matchRating": "Rating",
    "recentMatches": "Recent matches",
    "profile365": {
      "title": "Player profile",
      "via": "via 365Scores",
      "yearsOld": "{{count}} yrs",
      "bio": "Biography",
      "highlights": "Highlights",
      "career": "Career stats",
      "recentMatches": "Recent matches",
      "transfers": "Transfers",
      "current": "Current",
      "trophies": "Trophies"
    }
  },
  "challenges": {
    "title": "Challenges",
    "subtitle": "Match challenges",
    "howItWorks": "A fresh question before every match. Answer before kickoff to earn bonus points.",
    "vs": "vs",
    "q": {
      "result": "Who wins?",
      "overUnder": "Over or under 2.5 goals?",
      "btts": "Both teams to score?"
    },
    "opt": {
      "draw": "Draw",
      "over": "Over 2.5",
      "under": "Under 2.5",
      "yes": "Yes",
      "no": "No"
    },
    "open": "Open",
    "locked": "Locked",
    "resolved": "Resolved",
    "yourPick": "Your pick",
    "won": "+{{points}} pts",
    "missed": "Missed",
    "voteCount_one": "{{count}} answer",
    "voteCount_other": "{{count}} answers",
    "emptyTitle": "No challenges yet",
    "emptyBody": "New challenges drop each round. Check back soon."
  },
  "search": {
    "placeholder": "Players, teams, competitions…",
    "players": "Players",
    "teams": "Teams",
    "competitions": "Competitions",
    "startTypingTitle": "Find anything in football",
    "startTypingBody": "Search for a player, a club, or a competition.",
    "noResultsTitle": "No results for \"{{query}}\"",
    "noResultsBody": "Check the spelling or try a shorter name."
  },
  "auth": {
    "signIn": "Sign in",
    "signUp": "Create account",
    "signOut": "Sign out",
    "continueWithGoogle": "Continue with Google",
    "continueWithApple": "Continue with Apple",
    "continueWithFacebook": "Continue with Facebook",
    "orWithEmail": "or with email",
    "welcomeTitle": "Welcome to Tashkeela",
    "welcomeSubtitle": "Live scores, fantasy and predictions - in one place.",
    "createTitle": "Create your account",
    "createSubtitle": "Join free to build a squad, predict and climb the leaderboards.",
    "providerComingSoon": "{{provider}} sign-in is coming soon - use Google or email for now.",
    "email": "Email",
    "password": "Password",
    "displayName": "Display name",
    "haveAccount": "Already have an account? Sign in",
    "needAccount": "New here? Create an account",
    "onboardingTitle": "What should we call you?",
    "onboardingBody": "Pick the name shown on leaderboards and your predictions. You can change it later.",
    "onboardingTeamsTitle": "Follow your teams",
    "onboardingTeamsBody": "Tap the clubs and nations you love. We'll line up their matches to predict. You can refine leagues and players later.",
    "onboardingLeaguesTitle": "Follow competitions",
    "onboardingLeaguesBody": "We'll surface their matches, tables and news first.",
    "onboardingPlayersTitle": "Follow players",
    "onboardingPlayersBody": "Track their performances, ratings and transfers.",
    "searchTeams": "Search teams",
    "continue": "Continue",
    "next": "Next",
    "finish": "Done",
    "settingUp": "Setting up your account...",
    "verifyEmailTitle": "Check your inbox",
    "verifyEmailBody": "We sent a confirmation link to {{email}}. Verify it, then sign in.",
    "errors": {
      "invalidEmail": "That doesn't look like a valid email.",
      "shortPassword": "Password must be at least 8 characters.",
      "shortName": "Display name must be at least 2 characters.",
      "invalidCredentials": "Wrong email or password.",
      "emailTaken": "An account with this email already exists.",
      "emailNotConfirmed": "Please confirm your email first - check your inbox.",
      "generic": "Sign-in failed. Please try again."
    }
  },
  "profile": {
    "title": "Profile",
    "editProfile": "Edit profile",
    "editTitle": "Edit profile",
    "username": "Username",
    "usernamePlaceholder": "Pick a unique name",
    "usernameChecking": "Checking availability…",
    "usernameAvailable": "Available",
    "usernameTaken": "That name is already taken",
    "usernameInvalid": "3 to 20 letters, numbers, spaces, or . _ -",
    "avatarSynced": "Your photo is synced from your Google / Facebook account",
    "savedToast": "Profile updated",
    "statPoints": "Points",
    "statCorrect": "Correct",
    "statRank": "Rank",
    "settings": "Settings",
    "language": "Language",
    "theme": "Appearance",
    "themeDark": "Dark",
    "themeLight": "Light",
    "english": "English",
    "arabic": "العربية",
    "numerals": "Numerals",
    "westernNumerals": "English (123)",
    "arabicNumerals": "Arabic (١٢٣)",
    "preferences": "Preferences",
    "proSection": "Tashkeela Pro",
    "proTitle": "You're Pro ✨",
    "proActive": "Active, free during the test phase. Everything is unlocked.",
    "perk": {
      "noAds": "No ads",
      "advancedStats": "Advanced match stats and insights",
      "allGames": "All games and fantasy chips",
      "proBadge": "Pro profile badge"
    },
    "notifications": "Notifications",
    "widgets": "Home screen widgets",
    "badges": "Badges",
    "badgesCount": "{{unlocked}}/{{total}}",
    "goalAlerts": "Goal alerts",
    "goalsFollowedOnly": "Only my followed teams",
    "deadlineReminders": "Fantasy deadline reminders",
    "pushHint": "Delivered on the mobile app. Your choices here are saved and apply the moment you sign in on your phone.",
    "game": "Game guide",
    "howToPlay": "How to play & points",
    "account": "Account",
    "rewards": "Rewards",
    "referral": "Invite friends",
    "favoriteTeam": "Favourite team",
    "noFavoriteTeam": "Not set",
    "credits": "Data & credits",
    "deleteAccount": "Delete account",
    "deleteAccountConfirmTitle": "Delete your account?",
    "deleteAccountConfirmBody": "This permanently removes your profile, squads, and league memberships. This cannot be undone.",
    "restartForLanguage": "Restart the app to fully apply the new layout direction.",
    "guestTitle": "You're browsing as a guest",
    "guestBody": "Sign in to build a fantasy squad, join leagues, and save your preferences."
  },
  "credits": {
    "title": "Data & credits",
    "dataTitle": "Match data",
    "dataBody": "Live scores, fixtures, standings and player statistics come from licensed sports-data providers.",
    "ipTitle": "Logos & trademarks",
    "ipBody": "Team and competition logos are shown for identification purposes only. They remain the property of their respective clubs, federations and owners, and no affiliation or endorsement is implied.",
    "openSourceTitle": "Built with",
    "openSourceBody": "Expo, React Native, Supabase, NativeWind, TanStack Query and i18next - all open source."
  },
  "fantasy": {
    "title": "Fantasy",
    "challengesPopup": {
      "title": "Today's challenges",
      "body": "A quick question before every match. Answer before kickoff to earn bonus points.",
      "cta": "Play now",
      "later": "Maybe later"
    },
    "onboarding": {
      "title": "Pick your game",
      "subtitle": "Choose a competition to play fantasy in. You can join more later.",
      "teamNameTitle": "Name your team",
      "teamNamePlaceholder": "e.g. Desert Falcons",
      "start": "Build my squad",
      "noCompetitionsTitle": "No fantasy competitions yet",
      "noCompetitionsBody": "Fantasy opens for competitions with full player statistics. Check back after the next data sync."
    },
    "builder": {
      "title": "Squad Builder",
      "budget": "Budget",
      "remaining": "{{amount}}m left",
      "overBudget": "{{amount}}m over budget",
      "picked": "{{count}} / {{total}} picked",
      "starting": "Starting XI",
      "bench": "Bench",
      "captain": "Captain",
      "vice": "Vice-captain",
      "makeCaptain": "Make captain",
      "makeVice": "Make vice-captain",
      "moveToStarting": "Move to starting XI",
      "moveToBench": "Move to bench",
      "remove": "Remove from squad",
      "addPlayer": "Add player",
      "pickForSlot": "Pick a {{position}}",
      "saveSquad": "Save squad",
      "saving": "Saving…",
      "saved": "Squad saved",
      "needs": {
        "GK_one": "You need one more goalkeeper",
        "GK_other": "You need {{count}} more goalkeepers",
        "DEF_one": "You need one more defender",
        "DEF_other": "You need {{count}} more defenders",
        "MID_one": "You need one more midfielder",
        "MID_other": "You need {{count}} more midfielders",
        "FWD_one": "You need one more forward",
        "FWD_other": "You need {{count}} more forwards"
      },
      "positionFull": "Your {{position}} slots are full",
      "alreadyPicked": "Already in your squad",
      "needCaptain": "Choose a captain from your starting XI",
      "needVice": "Choose a vice-captain from your starting XI",
      "invalidFormation": "Your starting XI needs 1 GK, 3-5 DEF, 2-5 MID and 1-3 FWD",
      "searchPlayers": "Search players…",
      "sortPrice": "Price",
      "sortName": "Name",
      "random": "🎲 Surprise me",
      "randomDone": "Random squad ready. Tweak it or save.",
      "randomFailed": "Couldn’t build a squad from the pool."
    },
    "myTeam": {
      "title": "My Team",
      "captainHint": "Your captain scores ×{{multiplier}}",
      "gwPoints": "Gameweek points",
      "totalPoints": "Total points",
      "overallRank": "Overall rank",
      "viewPhotos": "Show player photos",
      "viewFlags": "Show nation flags",
      "viewClubs": "Show club crests",
      "provisional": "Provisional - final after all matches finish",
      "noTeamTitle": "No squad yet",
      "noTeamBody": "Build your 15-player squad and start scoring this gameweek.",
      "noTeamCta": "Build my squad",
      "editSquad": "Edit squad",
      "roundLocked": "Round is live, so your squad is locked. Any changes you make apply from the next round.",
      "pointsBreakdown": "Points breakdown",
      "noPointsYet": "Points appear once this gameweek's matches are scored.",
      "breakdown": {
        "minutes": "Minutes played",
        "goals": "Goals",
        "assists": "Assists",
        "clean_sheet": "Clean sheet",
        "saves": "Saves",
        "penalty_saved": "Penalty saved",
        "penalty_missed": "Penalty missed",
        "goals_conceded": "Goals conceded",
        "yellow": "Yellow card",
        "red": "Red card",
        "own_goals": "Own goal",
        "bonus": "Bonus",
        "captain": "Captain ×{{multiplier}}"
      }
    },
    "gameweek": {
      "title": "Gameweek {{number}}",
      "deadline": "Deadline",
      "deadlinePassed": "Deadline passed - lineups are locked",
      "countdown": "{{days}}d {{hours}}h {{minutes}}m",
      "countdownShort": "{{hours}}h {{minutes}}m",
      "transfersNote": "Changes saved after the deadline count from the next gameweek.",
      "yourFixtures": "Your players' matches",
      "noGameweekTitle": "No gameweek scheduled",
      "noGameweekBody": "Gameweeks appear once fixtures are synced for this competition."
    },
    "chips": {
      "title": "Chips",
      "hint": "One chip per gameweek, each once per tournament. Locks at the deadline.",
      "noTeam": "Save a squad first to use chips.",
      "tripleCaptain": "Triple Captain",
      "tripleCaptainDesc": "Your captain scores ×3 this round.",
      "benchBoost": "Bench Boost",
      "benchBoostDesc": "All 15 players score this round.",
      "freeHit": "Free Hit",
      "freeHitDesc": "Change your squad for this round only. It snaps back to your old team next round.",
      "wildcard": "Wildcard",
      "wildcardDesc": "Rebuild your squad free, with no transfer hits this round.",
      "play": "Play",
      "active": "Active",
      "used": "Used",
      "soon": "Soon",
      "armed": "{{chip}} armed for this gameweek",
      "removed": "Chip removed"
    },
    "transfers": {
      "title": "Transfers",
      "made_one": "{{count}} change · 1 free per round",
      "made_other": "{{count}} changes · 1 free per round",
      "free": "Free",
      "chipActive": "Free transfers"
    },
    "leaderboards": {
      "title": "Leaderboards",
      "overall": "Overall",
      "miniLeagues": "Mini-leagues",
      "rank": "Rank",
      "teamHeader": "Team",
      "pointsHeader": "Pts",
      "you": "You",
      "captainShort": "Ⓒ {{name}}",
      "createLeague": "Create a mini-league",
      "joinLeague": "Join with a code",
      "leagueName": "League name",
      "leagueNamePlaceholder": "e.g. Office Legends",
      "inviteCode": "Invite code",
      "inviteCodePlaceholder": "12-character code",
      "inviteCodeShare": "Share this code with friends: {{code}}",
      "codeCopied": "Code copied",
      "shareInvite": "Join my league \"{{name}}\" on Tashkeela! Code: {{code}}",
      "members_one": "{{count}} member",
      "members_other": "{{count}} members",
      "leave": "Leave league",
      "leaveConfirm": "Leave this mini-league?",
      "emptyOverallTitle": "No teams yet",
      "emptyOverallBody": "Be the first to build a squad in this competition.",
      "noLeaguesTitle": "No mini-leagues yet",
      "noLeaguesBody": "Create one and invite your friends, or join with a code.",
      "viewSquad": "View {{team}}'s squad",
      "managedBy": "by {{manager}}",
      "bench": "Bench",
      "squadHiddenTitle": "Lineup hidden",
      "squadHiddenBody": "This squad is revealed once the gameweek deadline passes."
    },
    "competitions": {
      "worldCup": "World Cup 2026",
      "premierLeague": "Premier League",
      "soon": "Soon"
    }
  },
  "errors": {
    "AUTH_REQUIRED": "Please sign in first.",
    "RATE_LIMITED": "Slow down a little - try again in a minute.",
    "SEASON_NOT_FOUND": "This fantasy game isn't open right now.",
    "INVALID_TEAM_NAME": "Team name must be 3-30 characters.",
    "INVALID_PICKS": "Your squad data looks wrong - refresh and try again.",
    "INVALID_SQUAD_SIZE": "Your squad must have exactly 15 players.",
    "DUPLICATE_PICKS": "Each player can only appear once in your squad.",
    "INVALID_STARTING_COUNT": "Your starting XI must have exactly 11 players.",
    "INVALID_CAPTAINCY": "Pick one captain and one vice-captain from your starting XI.",
    "PLAYER_NOT_IN_COMPETITION": "One of your players isn't in this competition.",
    "INVALID_FORMATION": "Your starting XI formation isn't allowed.",
    "BUDGET_EXCEEDED": "That squad is over budget.",
    "INVALID_LEAGUE_NAME": "League name must be 3-30 characters.",
    "NO_FANTASY_TEAM": "Build a squad in this competition first.",
    "LEAGUE_NOT_FOUND": "No league found for that code.",
    "DUEL_FULL": "This duel is already full (2 players).",
    "LEAGUE_FULL": "This league is full.",
    "NOT_A_MEMBER": "You're not a member of this league.",
    "INSUFFICIENT_FUNDS": "Not enough coins.",
    "DRAW_NOT_FOUND": "This draw has closed.",
    "AD_CAP_REACHED": "You've hit today's ad-reward limit. Come back tomorrow!",
    "AD_NOT_COMPLETED": "Watch the full ad to earn coins.",
    "TEAM_NOT_FOUND": "That team could not be found.",
    "INVALID_CHIP": "That chip isn't available.",
    "GAMEWEEK_NOT_FOUND": "That gameweek could not be found.",
    "DEADLINE_PASSED": "The deadline has passed - chips lock at the deadline.",
    "CHIP_ALREADY_USED": "You've already used that chip this season.",
    "CHIP_ALREADY_ACTIVE": "You already have a chip active for this gameweek.",
    "INVALID_PICK": "That pick isn't valid.",
    "INVALID_STAKE": "Pick one of the stake amounts.",
    "FIXTURE_NOT_FOUND": "We couldn't find that match.",
    "PREDICTION_NOT_AVAILABLE": "No odds for this match yet - check back later.",
    "ALREADY_PICKED": "You've already placed a pick on this match.",
    "PREDICTION_LOCKED": "Match already started.",
    "OAUTH_DISABLED": "Google sign-in isn't enabled yet - use email for now.",
    "network": "Network problem - check your connection.",
    "unknown": "Something went wrong. Please try again.",
    "SPIN_COOLDOWN": "You have already spun. Come back when the timer is up.",
    "GAMEWEEK_LIVE": "A round is live. You can spin again once it ends.",
    "INVALID_SPIN_COUNT": "Pick one or two players to boost.",
    "DUPLICATE_SPIN_PICKS": "You picked the same player twice.",
    "SPIN_PICKS_NOT_ONE_NATION": "Spin picks must come from the same nation.",
    "REFERRAL_INVALID": "That code doesn't look right.",
    "REFERRAL_NOT_FOUND": "No one has that code.",
    "REFERRAL_SELF": "You can't use your own code.",
    "REFERRAL_ALREADY_REDEEMED": "You've already redeemed a code.",
    "NOT_LIVE": "This match isn't live right now.",
    "ONE_PER_GROUP": "Pick one winner per group.",
    "ALREADY_DOUBLED": "You already doubled this reward.",
    "NO_REWARD_TO_DOUBLE": "There's nothing to double here yet.",
    "PREDICTION_NOT_SETTLED": "This prediction hasn't been scored yet.",
    "PREDICTION_NOT_FOUND": "We couldn't find that prediction.",
    "FREEZE_MAX": "You're at the max freezes.",
    "INVALID_PACK_KIND": "That pack type isn't available.",
    "NO_STICKERS": "Stickers aren't ready yet - check back soon.",
    "PACK_ALREADY_OPENED": "You've already opened today's free pack.",
    "ACCA_FULL": "Your card is full (6 matches max).",
    "FIXTURE_LOCKED": "This match has already kicked off.",
    "FIXTURE_NOT_IN_COMPETITION": "That match isn't part of this game.",
    "INVALID_SELECTION": "Pick home, draw, or away.",
    "NO_OPEN_ROUND": "No Survivor round is open right now.",
    "SURVIVOR_OUT": "You're out of Survivor, no pick this round.",
    "TEAM_ALREADY_USED": "You already used that team in an earlier round.",
    "TEAM_NOT_PLAYING": "That team isn't playing this round.",
    "CHALLENGE_NOT_FOUND": "That challenge isn't available.",
    "CHALLENGE_LOCKED": "This challenge is locked.",
    "INVALID_OPTION": "Pick a valid option.",
    "ITEM_NOT_FOUND": "That item isn't available.",
    "ITEM_INACTIVE": "That item isn't available right now.",
    "ALREADY_OWNED": "You already own this.",
    "NOT_OWNED": "You don't own this yet.",
    "GAMEWEEK_LOCKED": "This gameweek is locked.",
    "NEED_ELEVEN": "Pick all 11 players.",
    "DUPLICATE_PLAYER": "You picked the same player twice.",
    "CAPTAIN_NOT_IN_XI": "Your captain must be in your starting XI.",
    "PLAYER_NOT_FOUND": "That player could not be found."
  },
  "competitions": {
    "worldCup": "FIFA World Cup",
    "championsLeague": "UEFA Champions League",
    "premierLeague": "Premier League",
    "laLiga": "La Liga",
    "serieA": "Serie A",
    "bundesliga": "Bundesliga",
    "ligue1": "Ligue 1"
  },
  "spin": {
    "title": "Spin Boost",
    "cardBody": "Draw bonus players every 24h for extra points when they shine.",
    "ready": "Ready",
    "howItWorks": "Spin once every 24 hours to draw a nation, then pick 1 or 2 of its players. Each spin player who has a good gameweek (6+ points) earns you 50% of their points as a bonus on top of your team.",
    "activeTitle": "Active boosts",
    "boosted": "Boost",
    "liveNote": "A round is live now, so this spin's boost will count from the next round.",
    "nextSpinIn": "Next spin in",
    "extraSpinAd": "Watch ad - spin now",
    "buySpin": "Buy a spin · {{coins}}",
    "spinning": "Spinning…",
    "spinCta": "Spin",
    "choosePrompt": "Pick up to {{max}} players to boost",
    "reSpin": "Re-spin",
    "confirm": "Confirm boost",
    "noTeamTitle": "Build your squad first",
    "noTeamBody": "Create your World Cup fantasy team to unlock the Spin Boost."
  },
  "intro": {
    "headline": "Changing how you follow football",
    "subtitle": "Live scores, World Cup fantasy, predictions and transfers: one neon home for the beautiful game.",
    "getStarted": "Get started",
    "explore": "Explore without an account",
    "feature": {
      "live": "Live scores & match center",
      "fantasy": "World Cup fantasy + Spin Boost",
      "games": "Predict the bracket, climb leaderboards",
      "transfers": "Transfers & instant news"
    }
  }
}
